import { Component, OnDestroy, OnInit } from '@angular/core';
import { MENU } from './menu';
import { MenuItem } from './menu.model';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { Router } from '@angular/router';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { PatientSearchModalComponent } from 'src/app/pages/patient-search-modal/patient-search-modal.component';
import { environment } from 'src/environments/environment';
import { debounce } from 'lodash';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApplicationContextService } from 'src/app/core/services/application-context.service';
import { AdminScopeService } from 'src/app/core/services/admin-scope.service';
import { SUPER_ADMIN_QUEUE_MENU_IDS } from 'src/app/core/utils/admin-company.util';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})

export class SidebarComponent implements OnInit, OnDestroy {
  menuItems: MenuItem[] = [];
  showAppsPanel: boolean;
  expandSidebar: boolean = false;
  private readonly destroy$ = new Subject<void>();

  constructor(private readonly _router: Router,
    private readonly _modalService: BsModalService,
    private readonly _authService: AuthenticationService,
    private readonly _appContext: ApplicationContextService,
    private readonly _adminScope: AdminScopeService
  ) {
    this.menuItems = MENU;
  }

  ngOnInit(): void {
    combineLatest([this._appContext.context, this._adminScope.scope$])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([context, scope]) => {
        const isSuper = !!context.currentlyLoggedInUser?.superGlobalAdmin;
        const allOrgs = scope === 'all' && isSuper;
        if (allOrgs) {
          // All organizations: only cross-company review queues.
          this.menuItems = MENU.filter((item) =>
            SUPER_ADMIN_QUEUE_MENU_IDS.has(item.id as number)
          );
          return;
        }
        // Specific company (or normal admin): company tools only — no global queues.
        this.menuItems = MENU.filter(
          (item) => !SUPER_ADMIN_QUEUE_MENU_IDS.has(item.id as number)
        );
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  menuItemClicked(menuItem: MenuItem) {
    if (!menuItem.hasExternalLink) {
      return;
    }
    const linkWithToken = this._authService.appendEncryptedAuthInfo(menuItem.link);
    window.open(linkWithToken, '_blank');
  }

  openSettingsApp() {
    const linkWithToken = this._authService.appendEncryptedAuthInfo(environment.adminAppUrl);
    window.open(linkWithToken, '_blank');
  }

  isCurrentRoute(route: string): boolean {
    return this._router.url === route;
  }

  openSeachModal() {
    const options: ModalOptions = {
      class: 'patient-search-modal modal-lg',
      ignoreBackdropClick: true
    };
    this._modalService.show(PatientSearchModalComponent, options);
  }

  showAllTools(evt: Event) {
    this.showAppsPanel = true;
    this.expandSidebar = false;
    evt.stopPropagation();
  }

  expandSidebarWithDebouce = debounce((flag) => this.expandSidebar = flag, 300);
}
